module.exports = "/content/b47b08d837b1a880dc9acf4da773f936.png";